import bg from '@/assets/bgs/bg.jpg'
import bg0 from '@/assets/bgs/bg0.png'
import bg1 from '@/assets/bgs/bg1.png'
import bg2 from '@/assets/bgs/bg2.png'
import bg3 from '@/assets/bgs/bg3.png'
import carouselbg from '@/assets/carousel.png'

export const menu = [
  { idx: 0, type: 'banner', title: ['首页'], bg: "https://i0.hdslb.com/bfs/activity-plat/static/20210105/9c08a63ab84921ef52fe82b797ef77f2/LcgN2Zx2b.webp" },
  { idx: -1, type: 'gap', title: ['动画作品'] },
  {
    idx: 1,
    type: 'ranklist',
    title: [ '2020用户票选', '年度动画' ],
    bg: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/bbTkeQgcE.jpg@1960w_1c_100q.jpg',
    information:
      '在疫情的影响下，2020年的新番作品虽然数量减少，但依然不乏亮眼之作。《进击的巨人》最终季、《Re0》第二季、《超炮T》等热门续作的质量不负众望，几乎承包了各季度的霸权。完全新作《咒术回战》凭借超高的人气和口碑杀出重围，同期开播的《魔女之旅》也成为了一匹令人惊喜的黑马。《鬼灭之刃》和《命运之夜》两部剧场版尽管尚未在国内上映，却已是呼声一片。未来，永远有值得期待的动画在路上。',
    list: [
      {
        name: '进击的巨人 最终季',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/PGQmaFCtPQ.jpg@376w_524h_1c_100q.jpg',
        count: '520929',
      },
      {
        name: '咒术回战',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210118/9c08a63ab84921ef52fe82b797ef77f2/8MhiHKzgNmd.jpg@376w_524h_1c_100q.jpg',
        count: '159661',
      },
      {
        name: 'Re：从零开始的异世界生活 第二季',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210118/9c08a63ab84921ef52fe82b797ef77f2/sF9g7xuzjvh.jpg@376w_524h_1c_100q.jpg',
        count: '143371',
      },
      {
        name: '某科学的超电磁炮T',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/kmgsBwfeGZ.jpg@376w_524h_1c_100q.jpg',
        count: '137981',
      },
      {
        name: '魔女之旅',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/hrQ~MM-ei6.jpg@376w_524h_1c_100q.jpg',
        count: '130543',
      },
      {
        name: '辉夜大小姐想让我告白？～天才们的恋爱头脑战～',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/sBXpYipWW-.jpg@376w_524h_1c_100q.jpg',
        count: '91877',
      },
      {
        name: '鬼灭之刃 剧场版 无限列车篇',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/deFEC~ckyn.jpg@376w_524h_1c_100q.jpg',
        count: '82851',
      },
      {
        name: '约战狂三外传',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/WTIk1gbne3.jpg@376w_524h_1c_100q.jpg',
        count: '42181',
      },
      {
        name: '名侦探柯南',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210118/9c08a63ab84921ef52fe82b797ef77f2/ZR2r43~gg~n.jpg@376w_524h_1c_100q.jpg',
        count: '37490',
      },
      {
        name: '命运之夜——天之杯Ⅲ：春之歌',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/xK8MiIJ~69.jpg@376w_524h_1c_100q.jpg',
        count: '34223',
      },
    ],
  },
  { idx: 2, type: 'ranklist', title: [ '2020年度热门', '日本新作' ],
    bg: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/0QRGta13R.jpg@1960w_1c_100q.jpg',
    information: '在现象级作品层出不穷的当下，能够成为“年度热门”的新作，往往会通过富有话题性的故事题材和内容情节，激发观众讨论的热情和创作的动力。魔性洗脑的OP/ED和名场面，为无数衍生内容的创作提供了现成的“模板”。回到动画本身，近些年观众的讨论焦点逐渐从争议现实话题转向各类超现实的新奇设定，原创动画《异度侵入》成为开年最大惊喜。而无论在哪个年代哪个季度，“狗粮”一直是必不可少的追番伴侣。',
  list: [
    { name:'咒术回战', pic:'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/wJdVerFNlM.jpg@376w_524h_1c_100q.jpg', count:'274064408',},
    { name:'公主连结Re:Dive', pic:'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/ee25pUQ0SC.jpg@376w_524h_1c_100q.jpg', count:'260753087',},
    { name:'异度侵入 ID:INVADED', pic:'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/COlXGv7kAm.png', count:'113025007',},
    { name:'地缚少年花子君', pic:'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/Gn8LFV9zrq.jpg@376w_524h_1c_100q.jpg', count:'111902151',},
    { name:'因为太怕痛就全点防御力了', pic:'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/jMpO4Zjf2V.jpg@376w_524h_1c_100q.jpg', count:'56541513',},
    { name:'总之就是非常可爱', pic:'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/TfGy1yN3VB.jpg@376w_524h_1c_100q.jpg', count:'53047338',},
    { name:'虚构推理', pic:'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/lYO9KzHV9M.jpg@376w_524h_1c_100q.jpg', count:'52473437',},
    { name:'催眠麦克风-Division Rap Battle- Rhyme Anima', pic:'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/YaluFtaaBE.jpg@376w_524h_1c_100q.jpg', count:'43770125',},
    { name:'宇崎学妹想要玩！', pic:'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/p5e8ewl6CB.jpg@376w_524h_1c_100q.jpg', count:'37767993',},
    { name:'魔女之旅', pic:'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/hrQ~MM-ei6.jpg@376w_524h_1c_100q.jpg', count:'37312545',},
  ] },
  { idx: 3, type: 'ranklist', title: [ '2020年度热门', '日本续作' ],
    bg: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/63H1~dAuA.jpg@1960w_1c_100q.jpg',
    information: '在“爷青回”的2020年，有不少让粉丝等候或长或短的情怀续作陆续登场。无论是不负众望还是不尽人意，大IP的热度始终居高不下。在有原作内容支撑和庞大粉丝基础的前提下，续作的质量很难继续使用统一的标准进行判断，相关内容的数据表现与用户票选的结果也并不完全一致。令人欣慰的是，多数续作在前作的光环下表现依旧令人满意，甚至超出预期；在多部新番延期的背景下，为观众提供了可靠的选择。',
  list: [
    { name: '进击的巨人 最终季', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/SiN6K9FLzn.jpg@376w_524h_1c_100q.jpg', count:'631123322', },
    { name: '辉夜大小姐想让我告白？～天才们的恋爱头脑战～', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/MuU18iPphb.jpg@376w_524h_1c_100q.jpg', count:'524745577', },
    { name: '刀剑神域 爱丽丝篇 异界战争 -终章-', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/a5CRAD~VOQ.jpg@376w_524h_1c_100q.jpg', count:'515690482', },
    { name: '某科学的超电磁炮T', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/GjeGX0zOSs.jpg@376w_524h_1c_100q.jpg', count:'397949012', },
    { name: 'Re：从零开始的异世界生活 第二季', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210118/9c08a63ab84921ef52fe82b797ef77f2/sF9g7xuzjvh.jpg@376w_524h_1c_100q.jpg', count:'287817505', },
    { name: '我的青春恋爱物语果然有问题。完', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/iLkgbB-Rus.jpg@376w_524h_1c_100q.jpg', count:'184048084', },
    { name: 'BanG Dream! 梦想协奏曲 第三季', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/YGQdqvCiWE.jpg@376w_524h_1c_100q.jpg', count:'73949345', },
    { name: '排球少年！！ TO THE TOP', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/JQAxGoIl9C.jpg@376w_524h_1c_100q.jpg', count:'67716577', },
    { name: '鬼灭之刃 剧场版 无限列车篇', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/LXcx8sitpH.jpg@376w_524h_1c_100q.jpg', count:'40574912', },
    { name: '请问您今天要来点兔子吗？BLOOM', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/N23DjrJXVm.jpg@376w_524h_1c_100q.jpg', count:'36089375', }
  ]},
  {
    idx: 4,
    type: 'tabranklist',
    // bg: bg2,
    title: [''],
    groups: [
      {
        title: [ '2020年度热门', '长篇动画' ],
        list: [
          { name:'航海王', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/MPvm26UMkH.jpg@376w_524h_1c_100q.jpg', count:'790244645', },
          { name:'海绵宝宝', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/UyWWIzkDAt.jpg@376w_524h_1c_100q.jpg', count:'706735028', },
          { name:'名侦探柯南', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210118/9c08a63ab84921ef52fe82b797ef77f2/mm89eP8eBhd.jpg@376w_524h_1c_100q.jpg', count:'617571293', },
          { name:'哆啦A梦', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/Yge39X2~w.jpg@376w_524h_1c_100q.jpg', count:'233291334', },
          { name:'蜡笔小新', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/hgfQVpjrg4.jpg@376w_524h_1c_100q.jpg', count:'207342676', },
          { name:'小猪佩奇', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/hK43udAtHT.jpg@376w_524h_1c_100q.jpg', count:'134203850', },
          { name:'博人传 火影忍者新时代', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/ygHWiM~g2F.jpg@376w_524h_1c_100q.jpg', count:'125558533', },
          { name:'樱桃小丸子', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/der0AHcxoU.jpg@376w_524h_1c_100q.jpg', count:'88343459', },
          { name:'RWBY', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/5d6mrfEh5N.jpg@376w_524h_1c_100q.jpg', count:'59106707', },
          { name:'辛普森一家', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/4UzDGUzoIH.jpg@376w_524h_1c_100q.jpg', count:'32427320', },
        ],
        bg: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/3aYWyUSZVQ.jpg@1960w_1c_100q.jpg',
        // bgh5: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/0DD~cIJlr.jpg'
      },
      {
        title: [ '2020年度热门', '系列动画' ],
        list: [
          { name: 'JOJO的奇妙冒险系列', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/fYM-fAO5b6.jpg@376w_524h_1c_100q.jpg', count:'2965575715', },
          { name: 'Fate系列', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/zlZsA3edC5.jpg@376w_524h_1c_100q.jpg', count:'574354239', },
          { name: '机动战士高达系列', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/d52PFvYCEp.jpg@376w_524h_1c_100q.jpg', count:'436955260', },
          { name: '宝可梦系列', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/zgl6pFUDf0.jpg@376w_524h_1c_100q.jpg', count:'270348503', },
          { name: '黑塔利亚系列', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/QLqjihR~YA.jpg@376w_524h_1c_100q.jpg', count:'252058912', },
          { name: '龙珠系列', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/biIK2Pq6Z9.jpg@376w_524h_1c_100q.jpg', count:'247548279', },
          { name: '数码宝贝系列', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/KgrRtfTu8F.jpg@376w_524h_1c_100q.jpg', count:'175516891', },
          { name: '变形金刚系列', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/aBwpXH4HXu.jpg@376w_524h_1c_100q.jpg', count:'112799067', },
          { name: '小马宝莉系列', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/qb2vcuQ3i7.jpg@376w_524h_1c_100q.jpg', count:'112639280', },
          { name: '游戏王系列', pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/x~a0tJQHlb.jpg@376w_524h_1c_100q.jpg', count:'106887131', },
        ],
        bg: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/AeD8AmYaKQ.jpg@1960w_1c_100q.jpg',
        // bgh5: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/XehZhmsiM.jpg'
      },
    ],
  },
  {
    idx: 5,
    type: 'showcase',
    title: [ '2020年度动画', '优秀稿件欣赏' ],
    list: [
      'BV1oX4y1T7yM',
      'BV1cT4y1M71P',
      'BV1XD4y1X7kN',
      'BV1i54y1q7Y3',
      'BV1Bt4y1Q7Mw',
      'BV1T7411V7sh',
    ],
    bg: bg,
  },
  { idx: 6, type: 'ranklist', title: [ '2020用户票选', '往年动画' ],
    information: '作为2010年代日本动画的代表作之一，《进击的巨人》凭借宏大的故事线与一流的制作水准强势包揽榜单前二，多部经典作品在续作热度的加持下抵达记忆的顶端。有些故事虽已完结多年，至今仍在爱好者心中占有一席之地。那些耳熟能详的歌曲、中二或至理的台词、刻入DNA的名场面，都是宝贵的青春记忆。写作人生的《CLANNAD》，永不毕业的《轻音少女》……我们怀念的不仅是动画本身，还有与它们初次相遇时的自己。',
    bg: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/cDsoGRIKQ.jpg@1960w_1c_100q.jpg',
    list: [
    {
      name: '进击的巨人 第三季',
      pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/eUPXfQIvaR.jpg@376w_524h_1c_100q.jpg',
      count: '163409',
    },
    {
      name: '进击的巨人',
      pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/SCw8qhZSEL.jpg@376w_524h_1c_100q.jpg',
      count: '70776',
    },
    {
      name: 'CLANNAD',
      pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210118/9c08a63ab84921ef52fe82b797ef77f2/60u2EBcRTz.jpg@376w_524h_1c_100q.jpg',
      count: '68273',
    },
    {
      name: '某科学的超电磁炮',
      pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/MGhkuGtAz7.jpg@376w_524h_1c_100q.jpg',
      count: '37674',
    },
    {
      name: 'JOJO的奇妙冒险 星尘远征军',
      pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210118/9c08a63ab84921ef52fe82b797ef77f2/rJj3gNii42T.jpg@376w_524h_1c_100q.jpg',
      count: '34188',
    },
    {
      name: 'EVA 新世纪福音战士',
      pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/jG5QiuIU-o.jpg@376w_524h_1c_100q.jpg',
      count: '26883',
    },
    {
      name: '鬼灭之刃',
      pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/3haiev4N-h.jpg@376w_524h_1c_100q.jpg',
      count: '25743',
    },
    {
      name: 'Code Geass 反叛的鲁路修',
      pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/PRj35-rjXg.jpg@376w_524h_1c_100q.jpg',
      count: '24651',
    },
    {
      name: '轻音少女',
      pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/pW9gl5IBGp.jpg@376w_524h_1c_100q.jpg',
      count: '24426',
    },
    {
      name: '末日时在做什么？有没有空？可以来拯救吗？',
      pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/PMMHKMgrV0.jpg@376w_524h_1c_100q.jpg',
      count: '23010',
    },
  ], },
  {
    idx: 7,
    type: 'tabranklist',
    // bg: bg1,
    title: [''],
    groups: [
      { title: [ '2020年度热门', '往年日本动画' ],
        bg: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/-tb6ogcT1W.jpg@1960w_1c_100q.jpg',
        //bgh5: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/7qy8bDRxA.jpg',
        list: [
          {
            name: '火影忍者',
            pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/YBFaIDqZ2~.jpg@376w_524h_1c_100q.jpg',
            count: '1510854479',
          },{
            name: '鬼灭之刃',
            pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/n0BpDLvvlY.jpg@376w_524h_1c_100q.jpg',
            count: '1076978752',
          },{
            name: '校园小子',
            pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/W4G6gkR6MU.jpg@376w_524h_1c_100q.jpg',
            count: '496145209',
          },{
            name: '你的名字。',
            pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/A-Zr1GOqjn.jpg@376w_524h_1c_100q.jpg',
            count: '404252368',
          },{
            name: 'JOJO的奇妙冒险 黄金之风',
            pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/FKQpDOA1zw.jpg@376w_524h_1c_100q.jpg',
            count: '345037058',
          },{
            name: '文豪野犬',
            pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/0ufMGtlHEa.jpg@376w_524h_1c_100q.jpg',
            count: '295319384',
          },{
            name: '一拳超人',
            pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/KjIC1UgHsM.jpg@376w_524h_1c_100q.jpg',
            count: '250946150',
          },{
            name: '天气之子',
            pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/e1Y5Mnja8W.jpg@376w_524h_1c_100q.jpg',
            count: '248302040',
          },{
            name: '紫罗兰永恒花园',
            pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/o5RHuPcIdG.jpg@376w_524h_1c_100q.jpg',
            count: '243358194',
          },{
            name: 'EVA 新世纪福音战士',
            pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/pOP0zP3jt6.jpg@376w_524h_1c_100q.jpg',
            count: '241319830',
          },
        ]
      },
      { title: [ '2020年度热门', '往年欧美动画' ], bg: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/PYoyhJbYz5.jpg@1960w_1c_100q.jpg', list: [
        {
          name: '猫和老鼠',
          pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/Y~njMptrs.jpg@376w_524h_1c_100q.jpg',
          count: '729747379',
        },{
          name: '冰雪奇缘',
          pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/vRZmKbRRV.jpg@376w_524h_1c_100q.jpg',
          count: '193340645',
        },{
          name: '成龙历险记',
          pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/fWkzRxAiGg.jpg@376w_524h_1c_100q.jpg',
          count: '131872122',
        },{
          name: '米奇妙妙屋',
          pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/iiG9sEoNxr.jpg@376w_524h_1c_100q.jpg',
          count: '61159458',
        },{
          name: '夏洛克福尔摩斯和四大奇案',
          pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/pJPZFRXeBJ.jpg@376w_524h_1c_100q.jpg',
          count: '53171934',
        },{
          name: '蝙蝠侠',
          pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/7MVEbbhdvk.jpg@376w_524h_1c_100q.jpg',
          count: '50229183',
        },{
          name: '氰化欢乐秀',
          pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/NyKUZhc8Qs.jpg@376w_524h_1c_100q.jpg',
          count: '45268880',
        },{
          name: '怪诞小镇',
          pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/2FU~R89ltL.jpg@376w_524h_1c_100q.jpg',
          count: '39713590',
        },{
          name: '飞出个未来',
          pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/~nvYjYg0cv.jpg@376w_524h_1c_100q.jpg',
          count: '35350703',
        },{
          name: '蜘蛛侠',
          pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/ZPvD7G6pTH.jpg@376w_524h_1c_100q.jpg',
          count: '28306882',
        },
      ]},
    ],
  },
  { idx: 8, type: 'showcase', title: [ '往年动画', '优秀稿件欣赏' ], bg: bg, list: [
    'BV1Yi4y1V7Kr',
    'BV1Dy4y1q7Lp',
    'BV1gv411q7yv',
    'BV12p4y1i7dp',
    'BV1ip4y1z714',
    'BV11E411L7yu',
  ] },
  { idx: -1, type: 'gap', title: ['动画角色'] },
  {
    idx: 9,
    type: 'ranklist',
    title: [ '2020用户票选', '年度动画角色' ],
    information: '从最初单纯无畏的少年，到最终季的形象蜕变，艾伦·耶格尔的魅力始终深深感染着《进击的巨人》这部作品的观众们。“镇站之宝”御坂美琴傲娇可爱的模样十年如初，依旧是粉丝心中不变的信仰。观众或许会在每年的新作开播后“见异思迁”，但在选择挚爱时仍显专情。除了那些熟悉的面孔外，“人民教师”五条悟和“魔女之鉴”伊蕾娜两位人气“新人”入榜，也证明了强大而富有个性的角色永远都具有吸引力。',
    list: [
      {
        role: "艾伦·耶格尔",
        name: "进击的巨人 最终季",
        pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210115/9c08a63ab84921ef52fe82b797ef77f2/nOsYjSuQzXK.jpg@376w_524h_1c_100q.jpg",
        count: "249537"
      },
      {
        role: "御坂美琴",
        name: "某科学的超电磁炮T",
        pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/Qn~uk-yKCd.jpg@376w_524h_1c_100q.jpg",
        count: "120679"
      },
      {
        role: "利威尔·阿克曼",
        name: "进击的巨人 最终季",
        pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/uyVc2cVraS.jpg@376w_524h_1c_100q.jpg",
        count: "100811"
      },
      {
        role: "伊蕾娜",
        name: "魔女之旅",
        pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/9ZTM6JEDAE.jpg@376w_524h_1c_100q.jpg",
        count: "88132"
      },
      {
        role: "五条悟",
        name: "咒术回战",
        pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/j8bFlUD7jy.jpg@376w_524h_1c_100q.jpg",
        count: "78828"
      },
      {
        role: "时崎狂三",
        name: "约战狂三外传",
        pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/yIm5tcCoJ~.jpg@376w_524h_1c_100q.jpg",
        count: "69859"
      },
      {
        role: "阿尔托莉雅·潘德拉贡",
        name: "命运之夜——天之杯Ⅲ：春之歌",
        pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/oIAXRvE4El.jpg@376w_524h_1c_100q.jpg",
        count: "61607"
      },
      {
        role: "灰原哀",
        name: "名侦探柯南",
        pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/RTiwhmrBy~.jpg@376w_524h_1c_100q.jpg",
        count: "48991"
      },
      {
        role: "雷姆",
        name: "Re：从零开始的异世界生活 第二季",
        pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210115/9c08a63ab84921ef52fe82b797ef77f2/NIyCVEX94u4.jpg@376w_524h_1c_100q.jpg",
        count: "37744"
      },
      {
        role: "雪之下雪乃",
        name: "我的青春恋爱物语果然有问题。完",
        pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210107/9c08a63ab84921ef52fe82b797ef77f2/sVnbKormK.png",
        count: "35960"
      }
    ],
    bg: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/ffeL~rvKg.jpg@1960w_1c_100q.jpg',
  },
  {
    idx: 10,
    type: 'tabranklist',
    // bg: bg2,
    title: [''],
    groups: [
      { title: [ '2020年度热门', '日本男性角色' ],
        bg: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/zZcpalB4vM.JPG@1960w_1c_100q.jpg',
        list: [
        {
          role: "漩涡鸣人",
          name: "博人传 火影忍者新时代",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/VOYCtaHp1.png",
          count: "349974665"
        },
        {
          role: "宇智波佐助",
          name: "博人传 火影忍者新时代",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/CQegjJQe7C.png",
          count: "252243284"
        },
        {
          role: "工藤新一（江户川柯南）",
          name: "名侦探柯南",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/lTpmM3Rgl.jpg@376w_524h_1c_100q.jpg",
          count: "226044694"
        },
        {
          role: "蒙奇·D·路飞",
          name: "航海王",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/GEt9dg9lkV.png",
          count: "225663898"
        },
        {
          role: "灶门炭治郎",
          name: "鬼灭之刃 剧场版 无限列车篇",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/xoS2RhaXZ-.jpg@376w_524h_1c_100q.jpg",
          count: "179322324"
        },
        {
          role: "罗罗诺亚·索隆",
          name: "航海王",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/wSKzaEbZe5.png",
          count: "177763273"
        },
        {
          role: "艾伦·耶格尔",
          name: "进击的巨人 最终季",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210115/9c08a63ab84921ef52fe82b797ef77f2/nOsYjSuQzXK.jpg@376w_524h_1c_100q.jpg",
          count: "165744688"
        },
        {
          role: "比企谷八幡",
          name: "我的青春恋爱物语果然有问题。完",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/zgssBCDeVE.jpg@376w_524h_1c_100q.jpg",
          count: "140478402"
        },
        {
          role: "我妻善逸",
          name: "鬼灭之刃 剧场版 无限列车篇",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/EHY~pDcA7R.jpg@376w_524h_1c_100q.jpg",
          count: "133439326"
        },
        {
          role: "桐人（桐谷和人）",
          name: "刀剑神域 爱丽丝篇 异界战争 -终章-",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/JmNG1YASCq.png",
          count: "132551391"
        }
      ]},
      { title: [ '2020年度热门', '日本女性角色' ],
        bg: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/Qo1EmUmWe.jpg@1960w_1c_100q.jpg',
        list: [
        {
          role: "御坂美琴",
          name: "某科学的超电磁炮T",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/Qn~uk-yKCd.jpg@376w_524h_1c_100q.jpg",
          count: "272743991"
        },
        {
          role: "雷姆",
          name: "Re：从零开始的异世界生活 第二季",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210115/9c08a63ab84921ef52fe82b797ef77f2/NIyCVEX94u4.jpg@376w_524h_1c_100q.jpg",
          count: "215434132"
        },
        {
          role: "灰原哀",
          name: "名侦探柯南",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/5cE4qt8MD0.jpg@376w_524h_1c_100q.jpg",
          count: "125638211"
        },
        {
          role: "灶门祢豆子",
          name: "鬼灭之刃 剧场版 无限列车篇",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/EPFB2A4bxo.jpg@376w_524h_1c_100q.jpg",
          count: "114130697"
        },
        {
          role: "藤原千花",
          name: "辉夜大小姐想让我告白？～天才们的恋爱头脑战～",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/H4P3ogHNlt.jpg@376w_524h_1c_100q.jpg",
          count: "109283800"
        },
        {
          role: "四宫辉夜",
          name: "辉夜大小姐想让我告白？～天才们的恋爱头脑战～",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/PaOukTuo0m.jpg@376w_524h_1c_100q.jpg",
          count: "100303461"
        },
        {
          role: "亚丝娜（结城明日奈）",
          name: "刀剑神域 爱丽丝篇 异界战争 -终章-",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/iwopX2NhD1.jpg@376w_524h_1c_100q.jpg",
          count: "92728039"
        },
        {
          role: "毛利兰",
          name: "名侦探柯南",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/8V5MU6ghrZ.png",
          count: "87986864"
        },
        {
          role: "爱蜜莉雅",
          name: "Re：从零开始的异世界生活 第二季",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/5DGNXxHCET.jpg@376w_524h_1c_100q.jpg",
          count: "83132502"
        },
        {
          role: "阿尔托莉雅·潘德拉贡",
          name: "命运之夜——天之杯Ⅲ：春之歌",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/v1CBc1h3hz.jpg@376w_524h_1c_100q.jpg",
          count: "69881640"
        }
      ]},
    ],
  },
  {
    idx: 11,
    type: 'showcase',
    title: [ '2020年度动画角色', '优秀稿件欣赏' ],
    bg: bg,
    list: [
      'BV1Wi4y157nN',
      'BV1kX4y1u7Qh',
      'BV1H7411E7jD',
      'BV1sV411y7Lo',
      'BV18A411v75S',
      'BV1mK411u7PY',
    ]
  },
  {
    idx: 12,
    type: 'ranklist',
    title: [ '2020用户票选', '往年动画角色' ],
    information: '“士兵们，愤怒吧！士兵们，咆哮吧！士兵们，战斗吧！”——在《进击的巨人》动画第三季中，团长埃尔文冷酷睿智、刚毅果决的形象，随着最后一次冲锋进一步得到了升华，为观众留下了无法磨灭的深刻印象。那些憧憬着幸福，却同样为了使命而消逝的女孩们的身影，也永久地印在了我们的脑海中。悲情的过往、交织的情感和信念、矛盾的抉择……正是角色的这些复杂多样性，令人感受到属于他们各自独一无二的魅力。',
    list: [
      {
        role: "埃尔文·史密斯",
        name: "进击的巨人",
        pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210115/9c08a63ab84921ef52fe82b797ef77f2/JPcW9OTJfgC.jpg@376w_524h_1c_100q.jpg",
        count: "194077"
      },
      {
        role: "02",
        name: "DARLING in the FRANXX",
        pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/UrjMtcAuJf.jpg@376w_524h_1c_100q.jpg",
        count: "64953"
      },
      {
        role: "珂朵莉·诺塔·瑟尼欧里斯",
        name: "末日时在做什么？有没有空？可以来拯救吗？",
        pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/YeyxeN9Bbm.jpg@376w_524h_1c_100q.jpg",
        count: "31569"
      },
      {
        role: "桔梗",
        name: "犬夜叉",
        pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/rY2QGJ~pwS.jpg@376w_524h_1c_100q.jpg",
        count: "28722"
      },
      {
        role: "C.C.",
        name: "Code Geass 反叛的鲁路修",
        pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/uzvQHwMjqj.jpg@376w_524h_1c_100q.jpg",
        count: "27461"
      },
      {
        role: "古河渚",
        name: "CLANNAD",
        pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210115/9c08a63ab84921ef52fe82b797ef77f2/ueBS8vZmGfU.jpg@376w_524h_1c_100q.jpg",
        count: "23563"
      },
      {
        role: "空条承太郎",
        name: "JOJO的奇妙冒险 星尘远征军",
        pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/-vdHYWy6t.jpg@376w_524h_1c_100q.jpg",
        count: "20950"
      },
      {
        role: "茵蒂克丝",
        name: "魔法禁书目录",
        pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210115/9c08a63ab84921ef52fe82b797ef77f2/I-gghb5qFM.png",
        count: "20507"
      },
      {
        role: "夜斗",
        name: "野良神",
        pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210115/9c08a63ab84921ef52fe82b797ef77f2/tR-rVvRTKqO.jpg@376w_524h_1c_100q.jpg",
        count: "19613"
      },
      {
        role: "夏目贵志",
        name: "夏目友人帐",
        pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210115/9c08a63ab84921ef52fe82b797ef77f2/sf~XvxZJ5Qf.jpg@376w_524h_1c_100q.jpg",
        count: "17872"
      }
    ],
    bg: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/APixzRfYa.jpg@1960w_1c_100q.jpg',
  },
  {
    idx: 13,
    type: 'tabranklist',
    bg: bg3,
    title: [''],
    groups: [
      { title: [ '2020年度热门', '往年日本男性角色' ],
      bg: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/ASxAkXoN0.png',
      list: [
        {
          role: "迪奥·布兰度",
          name: "JOJO的奇妙冒险",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/rptydOvSqJ.jpg@376w_524h_1c_100q.jpg",
          count: "794000363"
        },{
          role: "空条承太郎",
          name: "JOJO的奇妙冒险 星尘远征军",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/09iSIbbbZv.jpg@376w_524h_1c_100q.jpg",
          count: "607642109"
        },{
          role: "吉良吉影",
          name: "JOJO的奇妙冒险 不灭钻石",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/OefTkpfDpJ.jpg@376w_524h_1c_100q.jpg",
          count: "295721191"
        },{
          role: "奥尔加·伊兹卡",
          name: "机动战士高达 铁血的奥尔芬斯",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/tt~19lLGKL.png",
          count: "216756062"
        },{
          role: "乔鲁诺·乔巴纳",
          name: "JOJO的奇妙冒险 黄金之风",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/VpTrxbcewf.png",
          count: "159484814"
        },{
          role: "太宰治",
          name: "文豪野犬",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/2QcAaBEzx1.jpg@376w_524h_1c_100q.jpg",
          count: "157411667"
        },{
          role: "利威尔·阿克曼",
          name: "进击的巨人 最终季",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/uyVc2cVraS.jpg@376w_524h_1c_100q.jpg",
          count: "154414855"
        },{
          role: "花京院典明",
          name: "JOJO的奇妙冒险 星尘远征军",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/WP67SsaK31.png",
          count: "115068630"
        },{
          role: "乔瑟夫·乔斯达",
          name: "JOJO的奇妙冒险",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/LtLO83xgiF.png",
          count: "113261216"
        },{
          role: "宇智波斑",
          name: "火影忍者",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/groT0W~q1K.jpg@376w_524h_1c_100q.jpg",
          count: "111896742"
        },
      ] },
      { title: [ '2020年度热门', '往年日本女性角色' ],
        bg: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/oSkOAH5ht.png',
        list: [
        {
          role: "三笠·阿克曼",
          name: "进击的巨人",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/Cv6oA4kL8O.png",
          count: "110447946"
        },{
          role: "02",
          name: "DARLING in the FRANXX",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/KuyvSK4JQ3.jpg@376w_524h_1c_100q.jpg",
          count: "100614040"
        },{
          role: "樱岛麻衣",
          name: "青春猪头少年不会梦到兔女郎学姐",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/aQ0BStVRuP.jpg@376w_524h_1c_100q.jpg",
          count: "66075238"
        },{
          role: "惣流·明日香·兰格雷",
          name: "EVA 新世纪福音战士",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/ioRBbgAmkF.jpg@376w_524h_1c_100q.jpg",
          count: "59210398"
        },{
          role: "秋山澪",
          name: "轻音少女",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/b-JJwjhqr8.jpg@376w_524h_1c_100q.jpg",
          count: "55911808"
        },{
          role: "小鸟游六花",
          name: "中二病也要谈恋爱！",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/8fr5OnC4V7.jpg@376w_524h_1c_100q.jpg",
          count: "54195811"
        },{
          role: "阿库娅",
          name: "为美好的世界献上祝福！",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/Z6m2rsjhAy.jpg@376w_524h_1c_100q.jpg",
          count: "50436086"
        },{
          role: "绫波丽",
          name: "EVA 新世纪福音战士",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/gk-LnQlHD6.png",
          count: "48561821"
        },{
          role: "木之本樱",
          name: "魔卡少女樱",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/o~~ZNW~Kjb.jpg@376w_524h_1c_100q.jpg",
          count: "46556910"
        },{
          role: "高木同学",
          name: "擅长捉弄的高木同学",
          pic: "https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/syzBORtutc.jpg@376w_524h_1c_100q.jpg",
          count: "42450357"
        },
      ]},
    ],
  },
  {
    idx: 14,
    type: 'showcase',
    title: [ '往年动画角色', '优秀稿件欣赏' ],
    bg: bg,
    list: [
      'BV1gA411H7Do',
      'BV1yg4y187b3',
      'BV1fi4y1F7k3',
      'BV1H5411W7Ms',
      'BV1p64y1Z7ev',
      'BV1jT4y177XH',
    ]
  },
  { idx: -1, type: 'gap', title: ['特摄'] },
  {
    idx: 15,
    type: 'ranklist',
    title: [ '2020用户票选', '历代特摄' ],
    information: '年度话题作《泽塔·奥特曼》凭借优异表现破圈，吸引不少新鲜血液入坑特摄，《迪迦·奥特曼》在观众心中的经典地位依旧不可动摇。《巴啦啦小魔仙》和《铠甲勇士》入围前十，代表国产特摄进入观众视野。无论是奥特曼系列再度成为话题，还是假面骑士梗的大受欢迎，都让越来越多人意识到，特摄不只是童年情怀的代名词，也并不幼稚；它是一种文化象征，是一种英雄精神的传承。期待未来会有更多优秀的特摄作品诞生。',
    bg: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/3xlohowFOi.jpg@1960w_1c_100q.jpeg',
    list: [
      {
        name: '迪迦·奥特曼',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/BFKGOjLTmc.jpg@376w_524h_1c_100q.jpg',
        count: '248400',
      },
      {
        name: '泽塔·奥特曼',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/Yfi132f-Vq.jpg@376w_524h_1c_100q.jpg',
        count: '88134',
      },
      {
        name: '巴啦啦小魔仙',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/D59HbjFfZ7.jpg@376w_524h_1c_100q.jpg',
        count: '58613',
      },
      {
        name: '盖亚·奥特曼',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/2mLIomVckU.jpg@376w_524h_1c_100q.jpg',
        count: '17524',
      },
      {
        name: '艾斯·奥特曼',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/sH1iH4VJKo.jpg@376w_524h_1c_100q.jpg',
        count: '16771',
      },
      {
        name: '假面骑士Build',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/xekFF153oG.jpg@376w_524h_1c_100q.jpg',
        count: '15157',
      },
      {
        name: '艾克斯·奥特曼',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/bKKnZ1~kYg.jpg@376w_524h_1c_100q.jpg',
        count: '14419',
      },
      {
        name: '铁甲小宝',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/76Pu1627BI.jpg@376w_524h_1c_100q.jpg',
        count: '13135',
      },
      {
        name: '铠甲勇士',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/hnkdjH6wmy.jpg@376w_524h_1c_100q.jpg',
        count: '10825',
      },
      {
        name: '假面骑士Decade',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/VLtswp1hcb.jpg@376w_524h_1c_100q.jpg',
        count: '10012',
      },
    ]
  },
  {
    idx: 16,
    type: 'tabranklist',
    // bg: bg0,
    title: [''],
    groups: [
      { title: [ '2020年度热门', '特摄系列' ],
        bg: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/~QTqfmcIKF.jpg@1960w_1c_100q.jpg',
        list: [
        {
          name: '奥特曼系列',
          pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/TmM061Sa8.jpg@376w_524h_1c_100q.jpg',
          count: '1259156749',
        },{
          name: '假面骑士系列',
          pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/L3aHJx6Ri5.png',
          count: '1167676666',
        },{
          name: '铠甲勇士系列',
          pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/uD6zjg05zQ.jpg@376w_524h_1c_100q.jpg',
          count: '141830910',
        },{
          name: '舞法天女系列',
          pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/Mbn1y8CiGu.jpg@376w_524h_1c_100q.jpg',
          count: '85062758',
        },{
          name: '哥斯拉系列',
          pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/pLztydf5MA.jpg@376w_524h_1c_100q.jpg',
          count: '66386997',
        },{
          name: '超级战队系列',
          pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/Z06egn7A11.jpg@376w_524h_1c_100q.jpg',
          count: '61184289',
        },{
          name: '巴啦啦小魔仙系列',
          pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/uSO4B2WEh7.jpg@376w_524h_1c_100q.jpg',
          count: '44303097',
        },{
          name: '金属英雄系列',
          pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/WuEZv2pvF1.jpg@376w_524h_1c_100q.jpg',
          count: '35394674',
        },{
          name: '牙狼系列',
          pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/Gtp6JaeHj8.jpg@376w_524h_1c_100q.jpg',
          count: '19038984',
        },{
          name: '超星系列',
          pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/emCieRTeUd.jpg@376w_524h_1c_100q.jpg',
          count: '8156524',
        },
      ]},
      { title: [ '2020年度热门', '奥特曼' ], bg: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/9Bot4RHKk.jpg@1960w_1c_100q.jpg', list: [
        {
          name:'迪迦·奥特曼',	pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/vbXgO-qkD.jpg@376w_524h_1c_100q.jpg', count: '403168552'
        },{
          name:'泽塔·奥特曼',	pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/u43OFugIri.jpg@376w_524h_1c_100q.jpg', count: '191675580'
        },{
          name:'赛罗·奥特曼',	pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/bPeSmRKiYe.jpg@376w_524h_1c_100q.jpg', count: '142003550'
        },{
          name:'赛文·奥特曼',	pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/ymMOXXkyPm.jpg@376w_524h_1c_100q.jpg', count: '118141489'
        },{
          name:'欧布·奥特曼',	pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/dIg1ng9TyS.jpg@376w_524h_1c_100q.jpg', count: '95644318'
        },{
          name:'捷德·奥特曼',	pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/zIZi0IiqNA.png', count: '91883299'
        },{
          name:'泰罗·奥特曼',	pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/Et~envqNUu.jpg@376w_524h_1c_100q.jpg', count: '75402649'
        },{
          name:'盖亚·奥特曼',	pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/J3-5cKgfhO.jpg@376w_524h_1c_100q.jpg', count: '74910182'
        },{
          name:'雷欧·奥特曼',	pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/IaJzS2IXMi.jpg@376w_524h_1c_100q.jpg', count: '69465189'
        },{
          name:'艾斯·奥特曼',	pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/gMRsBEaUi6.jpg@376w_524h_1c_100q.jpg', count: '60723454'
        }
      ]},
      { title: [ '2020年度热门', '假面骑士' ], bg: 'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/lcqQCwr52.jpg@1960w_1c_100q.jpg', list: [
        { name:'假面骑士01', pic:'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/x3GfTa~q7.jpg@376w_524h_1c_100q.jpg', count:'206180793'},
        { name:'假面骑士时王', pic:'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/wwfSanC036.jpg@376w_524h_1c_100q.jpg', count:'173639966'},
        { name:'假面骑士Build', pic:'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/L3aHJx6Ri5.png', count:'166163834'},
        { name:'假面骑士Decade', pic:'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/1-ufBhqKca.jpg@376w_524h_1c_100q.jpg', count:'104029925'},
        { name:'假面骑士Ex-Aid', pic:'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/I8V4mqOHMk.jpg@376w_524h_1c_100q.jpg', count:'85031802'},
        { name:'假面骑士W', pic:'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/ScP9Q9Y6Ao.jpg@376w_524h_1c_100q.jpg', count:'65298053'},
        { name:'假面骑士圣刃', pic:'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/dEtZ9TVMWP.jpg@376w_524h_1c_100q.jpg', count:'61893570'},
        { name:'假面骑士空我', pic:'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/nFq0Lv-T06.jpg@376w_524h_1c_100q.jpg', count:'55509258'},
        { name:'假面骑士555', pic:'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/NbZ7q6lR-F.jpg@376w_524h_1c_100q.jpg', count:'50925805'},
        { name:'假面骑士Drive', pic:'https://i0.hdslb.com/bfs/activity-plat/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/~tyqjKut3c.jpg@376w_524h_1c_100q.jpg', count:'48236757'},
      ]},
    ],
  },
  {
    idx: 17,
    type: 'showcase',
    title: ['历代特摄', '优秀稿件欣赏'],
    bg: bg,
    list: [
      'BV177411k7KK',
      'BV1dK411u7hq',
      'BV1AK4y1k7KX',
      'BV1hE411s7P2',
      'BV1z54y127AM',
      'BV16i4y1t7Ru',
    ]
  },
  { idx: -1, type: 'gap', title: ['期待'] },
  {
    idx: 18,
    type: 'ranklist',
    information: '轻松高甜、笑点密集的校园恋爱喜剧《辉夜大小姐想让我告白》凭借稳定精良的制作，两个季度持续高能，续作期待值无出其右。等了三年又三年，《EVA》新剧场版终章千呼万唤始出来，最后会如何收尾？《关我史事》《工作细胞》《BEASTARS》等近两年的人气动画的第二季已在一月纷至沓来，还有一些作品时隔多年仍然牵动观众的心。或许过去的一年留有遗憾，但在2021年，我们有更多热爱的动画可以期待。',
    title: [ '2021最受期待', '动画' ],
    bg: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/R12LjfieZ.jpeg@1960w_1c_100q.jpeg',
    list: [
      {
        name: '辉夜大小姐想让我告白 第三季',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/-HtppGmrtE.jpg',
        count: '109859',
      },
      {
        name: 'EVA 新世纪福音战士新剧场版：终',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/X4RQY4KC7p.jpg',
        count: '89669',
      },
      {
        name: '关于我转生变成史莱姆这档事 第二季',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/CoQ6DV6EL-.jpg',
        count: '60037',
      },
      {
        name: '刀剑神域 进击篇',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/CINedN3omc.jpg',
        count: '49984',
      },
      {
        name: '吹响吧！上低音号 久美子三年级篇',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/V2fE26bWKX.jpg',
        count: '37859',
      },
      {
        name: '夏目友人帐 石起和可疑来访者',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/PFpvPYxp6s.jpg',
        count: '30368',
      },
      {
        name: '工作细胞 第二季',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/hP-m2rLrpe.jpg',
        count: '29226',
      },
      {
        name: '死神 千年血战篇',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/iYYMQxhN1G.jpg',
        count: '28749',
      },
      {
        name: '名侦探柯南：绯色的弹丸',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/ExHfE9x8h1.jpg',
        count: '26623',
      },
      {
        name: '动物狂想曲 / BEASTARS 第二季',
        pic: 'https://i0.hdslb.com/bfs/activity-plat/static/20210106/9c08a63ab84921ef52fe82b797ef77f2/Qe9mFx2OQ0.jpg',
        count: '25950',
      },
    ]
  },
  {
    idx: 19,
    type: 'finale',
    title: ['结束'],
    pics: [''],
    carousels: [
      { bg: carouselbg, link: 'http://www.bilibili.com' },
      { bg: carouselbg, link: 'http://www.bilibili.com' },
    ],
    bg: bg,
  },
  // {
  //   idx: 20,
  //   type: 'comment',
  //   title: ['评论留言'],
  //   bg: bg,
  // },
]

export const videoInfo = {
	"BV1Yi4y1V7Kr": {
		"pic": "http://i1.hdslb.com/bfs/archive/5b29decda6c061071b6732594e08f89c688c2f48.jpg",
		"name": "葉月Mashiro灬",
		"title": "追番11年视觉盛宴-2009-2020番剧记忆-哔哩哔哩干杯！"
	},
	"BV1oX4y1T7yM": {
		"pic": "http://i1.hdslb.com/bfs/archive/795fa54541227741b3be2d9cb1a64b2d7e8ce95d.jpg",
		"name": "旺仔大哥哥",
		"title": "【2020年度番剧混剪】 年年岁岁花相似，岁岁年年番不同"
	},
	"BV1XD4y1X7kN": {
		"pic": "http://i1.hdslb.com/bfs/archive/a737fa451d3423c9d564b69c45235b9ed2b57bb4.jpg",
		"name": "懿品沙画",
		"title": "【鬼灭之刃无限列车篇/沙画】他燃烧了整个夜晚，却在黎明到来时消逝"
	},
	"BV1Dy4y1q7Lp": {
		"pic": "http://i2.hdslb.com/bfs/archive/9ba1184f1d7fef5de11c002ff12af721b32d1e5b.jpg",
		"name": "热心市民周湿傅",
		"title": "如果火影是日常画风 火影×日常op"
	},
	"BV1T7411V7sh": {
		"pic": "http://i2.hdslb.com/bfs/archive/4510827abe85bbc7f1c5a75bddf58e8e94cc4a9c.jpg",
		"name": "红凛茶",
		"title": "【给FATE做个三维片头会是什么样子】萌新UP爆肝20天渲染上百小时自制FATE开场动画"
	},
	"BV1gA411H7Do": {
		"pic": "http://i1.hdslb.com/bfs/archive/8f15b90c8291f2b5ab7039c738505f85bba1d24b.jpg",
		"name": "在下老酷",
		"title": "错的不是我，而是The World"
	},
	"BV1hE411s7P2": {
		"pic": "http://i1.hdslb.com/bfs/archive/5aed80db08f740ae810cc185dc1c54c8338ff300.jpg",
		"name": "瓶子君152",
		"title": "入坑假面骑士不知道看哪个？这个视频帮你解决所有问题！"
	},
	"BV1AK4y1k7KX": {
		"pic": "http://i0.hdslb.com/bfs/archive/d0fcc3756736802b550c344df9cfddab9cb19d3d.jpg",
		"name": "-小镇时光人-",
		"title": "【话奥20】这是一条刺穿所有奥特曼的宿命线 -『奥特曼简史』"
	},
	"BV11E411L7yu": {
		"pic": "http://i0.hdslb.com/bfs/archive/3267cc91e7151e930d4b396234e35aab586cd8cd.jpg",
		"name": "生化企鹅EID",
		"title": "【冰雪奇缘】步 入 迷 惑"
	},
	"BV1i54y1q7Y3": {
		"pic": "http://i0.hdslb.com/bfs/archive/2e549af6a2bba16eee59703ad14e6dc6e00cd0f2.jpg",
		"name": "黯淡神殇",
		"title": "「刀剑神域十周年纪念」- 双剑交辉之时，许下守护你的诺言"
	},
	"BV1dK411u7hq": {
		"pic": "http://i0.hdslb.com/bfs/archive/7ab2c4127011beace4645f9fe88aec38791dcf1c.jpg",
		"name": "机智帅气的一炫君",
		"title": "【Ultra燃起来了/4K/泽塔完结纪念】加快速度！ 大声叫出我的名字！《ご唱和ください 我の名を》"
	},
	"BV1H5411W7Ms": {
		"pic": "http://i2.hdslb.com/bfs/archive/f215251af174886a39a8a2226546b9f5a77aeff1.jpg",
		"name": "老渡鸽",
		"title": "大家好，我是太宰治，今天我入驻b站啦！"
	},
	"BV1fi4y1F7k3": {
		"pic": "http://i2.hdslb.com/bfs/archive/21539a1f9663c7a021b50b0c792134c3b8e43981.jpg",
		"name": "利利那TD25",
		"title": "明日香，我们走！【TD25定格动画】EVA定格补完计划04"
	},
	"BV18A411v75S": {
		"pic": "http://i0.hdslb.com/bfs/archive/43082e3b73ac1c63b23abb0fdafa25be407de020.png",
		"name": "某门卫",
		"title": "(萝莉版) 从零开始的异世界生活"
	},
	"BV1ip4y1z714": {
		"pic": "http://i2.hdslb.com/bfs/archive/379069df87b6c23f6ce3784fe12d2fb2fcf8368e.jpg",
		"name": "庄不纯",
		"title": "猫和老鼠-2077"
	},
	"BV1Bt4y1Q7Mw": {
		"pic": "http://i0.hdslb.com/bfs/archive/3848306c8c2aaf79f20f4c1a61adf5ab2e6735ef.jpg",
		"name": "豆豆动漫T",
		"title": "海 鲜 三 大 将"
	},
	"BV1z54y127AM": {
		"pic": "http://i0.hdslb.com/bfs/archive/ae64a482622eecaf4bb0310d6f1133f2e8c817e4.jpg",
		"name": "神奇的老皮VFX",
		"title": "路 过 的 假 面 大 爷"
	},
	"BV1jT4y177XH": {
		"pic": "http://i1.hdslb.com/bfs/archive/d26ebafa640d947f3f8659f14941523581f79a26.jpg",
		"name": "拉环儿_",
		"title": "【 日 下 三 女 神 】"
	},
	"BV1sV411y7Lo": {
		"pic": "http://i2.hdslb.com/bfs/archive/d318c4d9894eabb25e00e7bc8bb9ca1cd84a0b57.jpg",
		"name": "上白石萌音",
		"title": "约会大作战~辉夜外传"
	},
	"BV1yg4y187b3": {
		"pic": "http://i0.hdslb.com/bfs/archive/e21c40329fbc8747fcbdaabfc97ed78e01afdc3c.jpg",
		"name": "MinorGhostShadow",
		"title": "［万恶之源］来与02共舞吧！"
	},
	"BV1p64y1Z7ev": {
		"pic": "http://i0.hdslb.com/bfs/archive/d222d5e488f2ec53978dfad26e706cfcb5f010c8.jpg",
		"name": "初二disease",
		"title": "【误解系/TOS】神明的游戏"
	},
	"BV16i4y1t7Ru": {
		"pic": "http://i0.hdslb.com/bfs/archive/2fea5582d7b45d3af2af12f56d6ce1e12656486f.jpg",
		"name": "千夏千虾千吓千",
		"title": "爆肝历时半年！【千张假面骑士变身动画】崇皇逢魔时王(rider厨的狂欢~)"
	},
	"BV1gv411q7yv": {
		"pic": "http://i0.hdslb.com/bfs/archive/a7a5145d7a8a9fe318a30967dc1503de9bdf7245.jpg",
		"name": "聚能阁的红茶P",
		"title": "【京都动画】这大概就是时代之泪吧"
	},
	"BV1Wi4y157nN": {
		"pic": "http://i0.hdslb.com/bfs/archive/d7d0ba2c154e4b69427df3e3d212bb3a9e98e901.jpg",
		"name": "月刺啾",
		"title": "【咒术回战meme/五条悟生贺】Machine Gun（有微量剧透注意）"
	},
	"BV177411k7KK": {
		"pic": "http://i2.hdslb.com/bfs/archive/2259dca4fdb2751fd7b5195e2bf8b82487d79acf.jpg",
		"name": "蓝调阿帕奇37",
		"title": "【MAD】↑↘→↗↘→→ P.A.R.T.Y!! 这是属于特摄的出招表10"
	},
	"BV1cT4y1M71P": {
		"pic": "http://i0.hdslb.com/bfs/archive/0fc137285dcbdbe5011594112bbaf514caeaf5ac.jpg",
		"name": "reAct木子",
		"title": "「巨人最终季」全体起立！燃尽自由的生命，也不愿在囚禁中苟活！！！"
	},
	"BV1H7411E7jD": {
		"pic": "http://i1.hdslb.com/bfs/archive/540c12d21c8738fbd46a9dffe7d25dfdd1a5fd28.jpg",
		"name": "S_zde菠萝桑",
		"title": "近百梗乱入！saber和炮姐的吃饭之旅！"
	},
	"BV12p4y1i7dp": {
		"pic": "http://i0.hdslb.com/bfs/archive/55ac9f32b8b22eb78085eca37534f18c96052b88.jpg",
		"name": "Devil青酱",
		"title": "“相比较晴天，我需要的人是你”「你的名字」是「天气之子」"
	},
	"BV1mK411u7PY": {
		"pic": "http://i1.hdslb.com/bfs/archive/dae0e8a5caa6a9b480570634efaccb3964596d0f.jpg",
		"name": "蜜瓜茶茶0v0",
		"title": "【手书】柯 术 回 战 （完整版）一起来找彩蛋吧！"
	},
	"BV1kX4y1u7Qh": {
		"pic": "http://i0.hdslb.com/bfs/archive/b9d3ddde831965d9294232a363d3a43c49da77f6.jpg",
		"name": "久远丶酱",
		"title": "【魔女之旅 完结纪念】这么可爱的屑魔女谁不爱呢？灰之魔女伊蕾娜的魔女之旅"
	}
}

export const MAXSectionCount = menu.filter(v => v.idx !== -1).length

export const mp3Link = 'https://activity.hdslb.com/blackboard/static/20210114/9c08a63ab84921ef52fe82b797ef77f2/zBw-nhKmc.mp3'
export const mp4Link = 'https://activity.hdslb.com/blackboard/static/20210115/9c08a63ab84921ef52fe82b797ef77f2/sAFNnLWVhW.mp4'